import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PopupMessage from "../components/PopupMessage";
import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import EditIcon from "@material-ui/icons/EditOutlined";
import SaveIcon from "@material-ui/icons/SaveOutlined";
import CancelIcon from "@material-ui/icons/CancelOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },
  redCell: {
    color: "red",
  },
  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },
  spacer: {
    flex: "1 1 100%",
  },

  table: {
    border: "1px solid black",
    margin: "20px",
    width: 700,
  },
});

class CompanyProfilePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      companyData: {},
      canEdit: false,
      editMode: false,
      viewPopup: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ errorString: "" });
  }

  componentDidMount() {
    fetch("on_company_profile_request", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          this.setState({ companyData: reply.companyData });
          this.setState({ canEdit: reply.canEdit });
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  handleEdit(e) {
    if (!this.state.editMode) {
      this.setState({ editMode: true });
    } else {
      if (this.props.viewOnly) {
        this.setState({
          errorString: getErrorString(
            "viewOnly.warning",
            "Operation not allowed in support mode."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      if (this.state.companyData.name.length === 0) {
        this.setState({
          errorString: getErrorString(
            "company.name.error",
            "Company Name is required."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      if (this.state.companyData.contact.length === 0) {
        this.setState({
          errorString: getErrorString(
            "company.contact.error",
            "Contact Name is required."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      if (this.state.companyData.phone.length === 0) {
        this.setState({
          errorString: getErrorString(
            "company.phone.error",
            "Phone Number is required."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      if (this.state.companyData.fax.length === 0) {
        this.setState({
          errorString: getErrorString(
            "company.fax.error",
            "Fax Number is required."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      if (this.state.companyData.email.length === 0) {
        this.setState({
          errorString: getErrorString(
            "company.email.error",
            "E-mail is required."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      this.saveChanges();
    }
  }
  handleCancel() {
    this.setState({ editMode: false });
    this.componentDidMount();
  }

  handleRadioChange = (event) => {
    let myData = this.state.companyData;
    myData.notifyFmt = event.target.value;
    this.setState({ companyData: myData });
  };

  handleName = (event) => {
    let myData = this.state.companyData;
    myData.name = event.target.value;
    this.setState({ companyData: myData });
  };

  handleContact = (event) => {
    let myData = this.state.companyData;
    myData.contact = event.target.value;
    this.setState({ companyData: myData });
  };

  handlePhone = (event) => {
    let myData = this.state.companyData;
    myData.phone = event.target.value;
    this.setState({ companyData: myData });
  };

  handleFax = (event) => {
    let myData = this.state.companyData;
    myData.fax = event.target.value;
    this.setState({ companyData: myData });
  };

  handleEmail = (event) => {
    let myData = this.state.companyData;
    myData.email = event.target.value;
    this.setState({ companyData: myData });
  };

  handleAddress1 = (event) => {
    let myData = this.state.companyData;
    myData.address1 = event.target.value;
    this.setState({ companyData: myData });
  };

  handleAddress2 = (event) => {
    let myData = this.state.companyData;
    myData.address2 = event.target.value;
    this.setState({ companyData: myData });
  };

  handleCity = (event) => {
    let myData = this.state.companyData;
    myData.city = event.target.value;
    this.setState({ companyData: myData });
  };

  handleState = (event) => {
    let myData = this.state.companyData;
    myData.state = event.target.value;
    this.setState({ companyData: myData });
  };

  handleZip = (event) => {
    let myData = this.state.companyData;
    myData.zip = event.target.value;
    this.setState({ companyData: myData });
  };

  handleCountry = (event) => {
    let myData = this.state.companyData;
    myData.country = event.target.value;
    this.setState({ companyData: myData });
  };

  saveChanges() {
    let myData = this.state.companyData;
    myData.secureToken = this.props.secureToken;
    this.setState({ companyData: myData });
    fetch("on_company_profile_save", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.state.companyData),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ editMode: false });
          this.props.onNameChange(this.state.companyData.name);
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }
  render() {
    const { classes } = this.props;
    let { t } = this.props;
    return (
      <div>
        <Paper className={classes.toolbar}>
          <Toolbar>
            <Typography variant="h6" color="primary">
              {this.state.editMode
                ? t("editCompProfile.label")
                : t("compProfile.label")}
              &nbsp;&nbsp;
            </Typography>
            {this.state.canEdit && (
              <Button
                color="primary"
                onClick={(event) => this.handleEdit(event)}
              >
                {this.state.editMode && <SaveIcon />}
                {!this.state.editMode && <EditIcon />}{" "}
                {this.state.editMode
                  ? t("saveEmpty.button")
                  : t("editEmpty.button")}
              </Button>
            )}
            &nbsp;&nbsp;&nbsp;&nbsp;
            {this.state.editMode && (
              <Button
                color="primary"
                onClick={(event) => this.handleCancel(event)}
              >
                <CancelIcon />
                &nbsp;{t("cancel.button")}
              </Button>
            )}
          </Toolbar>
        </Paper>
        <div className={classes.tableWrapper}>
          {this.state.errorString.length > 0 && !this.state.viewPopup && (
            <h3 style={{ color: "red" }}>{this.state.errorString} </h3>
          )}
          {this.state.viewPopup && this.state.errorString.length > 0 && (
            <PopupMessage
              title="Error"
              text={this.state.errorString}
              error={true}
              onClosePopup={this.onClosePopup}
            />
          )}

          {this.state.errorString.length === 0 && !this.state.editMode && (
            <table style={{ margin: 30 }}>
              <Paper elevation={6}>
                <tr>
                  <td width="200">
                    {" "}
                    <Typography variant="subheading" color="primary">
                      {t("companyName.header")}:
                    </Typography>
                  </td>
                  <td width="450"> {this.state.companyData.name}</td>
                  <td width="200">
                    {" "}
                    <Typography variant="subheading" color="primary">
                      &nbsp;&nbsp;{t("contactName.label")}:
                    </Typography>
                  </td>
                  <td width="450"> {this.state.companyData.contact}</td>
                </tr>
                <tr style={{ height: 10 }} />
                <tr>
                  <td width="200">
                    {" "}
                    <Typography variant="subheading" color="primary">
                      {t("phoneNumber.label")}:
                    </Typography>
                  </td>
                  <td width="450"> {this.state.companyData.phone}</td>
                  <td width="200">
                    {" "}
                    <Typography variant="subheading" color="primary">
                      &nbsp;&nbsp;{t("faxNumber.label")}:
                    </Typography>
                  </td>
                  <td width="450"> {this.state.companyData.fax}</td>
                </tr>
                <tr style={{ height: 10 }} />
                <tr>
                  <td width="200">
                    {" "}
                    <Typography variant="subheading" color="primary">
                      {t("emailAddress.label")}:
                    </Typography>
                  </td>
                  <td colSpan={3}> {this.state.companyData.email}</td>
                </tr>
                <tr style={{ height: 10 }} />
                <tr>
                  <td width="200">
                    {" "}
                    <Typography variant="subheading" color="primary">
                      {t("address1.label")}:
                    </Typography>
                  </td>
                  <td width="450"> {this.state.companyData.address1}</td>
                  <td width="200">
                    {" "}
                    <Typography variant="subheading" color="primary">
                      &nbsp;&nbsp;{t("address2.label")}:
                    </Typography>
                  </td>
                  <td width="450"> {this.state.companyData.address2}</td>
                </tr>
                <tr style={{ height: 10 }} />
                <tr>
                  <td width="200">
                    {" "}
                    <Typography variant="subheading" color="primary">
                      {t("city.label")}:
                    </Typography>
                  </td>
                  <td width="450"> {this.state.companyData.city}</td>
                  <td width="200">
                    {" "}
                    <Typography variant="subheading" color="primary">
                      &nbsp;&nbsp;{t("state.label")}:
                    </Typography>
                  </td>
                  <td width="450"> {this.state.companyData.state}</td>
                </tr>
                <tr style={{ height: 10 }} />
                <tr>
                  <td width="200">
                    {" "}
                    <Typography variant="subheading" color="primary">
                      {t("zip.label")}:
                    </Typography>
                  </td>
                  <td width="450"> {this.state.companyData.zip}</td>
                  <td width="200">
                    {" "}
                    <Typography variant="subheading" color="primary">
                      &nbsp;&nbsp;{t("country.label")}:
                    </Typography>
                  </td>
                  <td width="450"> {this.state.companyData.country}</td>
                </tr>
                <tr style={{ height: 10 }} />
                <tr>
                  <td width="200">
                    {" "}
                    <Typography variant="subheading" color="primary">
                      {t("notifyFormat.label")}:&nbsp;&nbsp;
                    </Typography>
                  </td>
                  <td width="450">
                    {" "}
                    {this.state.companyData.notifyFmt === "E"
                      ? t("email.label")
                      : t("fax.label")}
                  </td>
                </tr>
                <tr style={{ height: 10 }} />
                <tr>
                  <td colSpan={4}>
                    <Typography variant="subheading" color="primary">
                      {t("accountEnrollment.label")}{" "}
                      <i>
                        {" "}
                        {this.state.companyData.acctCre === "1"
                          ? t("enabled.label")
                          : t("disabled.label")}
                      </i>{" "}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      {t("dualFact.label")}{" "}
                      <i>
                        {this.state.companyData.dualAuth === "1"
                          ? t("enabled.label")
                          : t("disabled.label")}
                      </i>
                    </Typography>
                  </td>
                </tr>
              </Paper>
            </table>
          )}
          {this.state.errorString.length === 0 && this.state.editMode && (
            <table style={{ margin: 30 }}>
              <Paper elevation={6}>
                <tr>
                  <td width="650">
                    <TextField
                      margin="dense"
                      id="name"
                      label={t("companyName.header")}
                      type="text"
                      required
                      inputProps={{maxLength: 100,}}
                      defaultValue={this.state.companyData.name}
                      onChange={this.handleName}
                    />
                  </td>
                  <td width="650">
                    &nbsp;&nbsp;
                    <TextField
                      margin="dense"
                      id="contact"
                      label={t("contactName.label")}
                      type="text"
                      required
                      inputProps={{maxLength: 40,}}
                      defaultValue={this.state.companyData.contact}
                      onChange={this.handleContact}
                    />
                    <br />
                    <Typography variant="caption" color="primary">
                      {t("contactPerson.label")}
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      margin="dense"
                      id="phone"
                      label={t("phoneNumber.label")}
                      type="text"
                      required
                      inputProps={{maxLength: 20,}}
                      defaultValue={this.state.companyData.phone}
                      onChange={this.handlePhone}
                    />
                    <br />
                    <Typography variant="caption" color="primary">
                      &nbsp;(XXX) XXX - XXXX
                    </Typography>
                  </td>
                  <td>
                    &nbsp;&nbsp;
                    <TextField
                      margin="dense"
                      id="fax"
                      label={t("faxNumber.label")}
                      type="text"
                      required
                      inputProps={{maxLength: 20,}}
                      defaultValue={this.state.companyData.fax}
                      onChange={this.handleFax}
                    />
                    <br />
                    <Typography variant="caption" color="primary">
                      &nbsp;&nbsp;&nbsp;(XXX) XXX - XXXX
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <TextField
                      margin="dense"
                      id="email"
                      label={t("emailAddress.label")}
                      type="text"
                      required
                      inputProps={{maxLength: 250,}}
                      fullWidth
                      defaultValue={this.state.companyData.email}
                      onChange={this.handleEmail}
                    />
                    <br />
                    <Typography variant="caption" color="primary">
                      {t("enterCorrectEmail.label")}
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <TextField
                      margin="dense"
                      id="address1"
                      label={t("address1.label")}
                      type="text"
                      inputProps={{maxLength: 50,}}
                      fullWidth
                      defaultValue={this.state.companyData.address1}
                      onChange={this.handleAddress1}
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <TextField
                      margin="dense"
                      id="address2"
                      label={t("address2.label")}
                      type="text"
                      inputProps={{maxLength: 50,}}
                      fullWidth
                      defaultValue={this.state.companyData.address2}
                      onChange={this.handleAddress2}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      margin="dense"
                      id="city"
                      label={t("city.label")}
                      type="text"
                      inputProps={{maxLength: 40,}}
                      defaultValue={this.state.companyData.city}
                      onChange={this.handleCity}
                    />
                  </td>
                  <td>
                    &nbsp;&nbsp;
                    <TextField
                      margin="dense"
                      id="state"
                      label={t("state.label")}
                      type="text"
                      inputProps={{maxLength: 30,}}
                      defaultValue={this.state.companyData.state}
                      onChange={this.handleState}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      margin="dense"
                      id="zip"
                      label={t("zip.label")}
                      type="text"
                      inputProps={{maxLength: 15,}}
                      defaultValue={this.state.companyData.zip}
                      onChange={this.handleZip}
                    />
                  </td>
                  <td>
                    &nbsp;&nbsp;
                    <TextField
                      margin="dense"
                      id="country"
                      label={t("country.label")}
                      type="text"
                      inputProps={{maxLength: 20,}}
                      defaultValue={this.state.companyData.country}
                      onChange={this.handleCountry}
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <Typography variant="caption">
                      {t("notifyFormat.label")}&nbsp;&nbsp;
                    </Typography>
                    <FormControlLabel
                      value="I"
                      control={
                        <Radio
                          color="default"
                          checked={this.state.companyData.notifyFmt === "E"}
                          onChange={this.handleRadioChange}
                          value="E"
                          name="radioButton"
                        />
                      }
                      label={t("email.label")}
                    />
                    <FormControlLabel
                      value="V"
                      control={
                        <Radio
                          color="default"
                          checked={this.state.companyData.notifyFmt === "F"}
                          onChange={this.handleRadioChange}
                          value="F"
                          name="radioButton"
                        />
                      }
                      label={t("fax.label")}
                    />
                  </td>
                </tr>
              </Paper>
            </table>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(CompanyProfilePage));
